import React, { useEffect, useRef, useState } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { useWindowDimensions, View } from 'react-native';
import { ActivityIndicator, Card } from 'react-native-paper';
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import { SafeAreaView } from 'react-native-safe-area-context';
import CustomCalendar from '../../../components/CustomCalendar/CustomCalendar';
import CustomButton from '../../../components/CustomButton';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import CustomControlledInput from '../../../components/ControlledComponents/CustomControlledInput';
import CustomControlledCheckbox from '../../../components/ControlledComponents/CustomControlledCheckbox';
import { useHRAdminEmployees } from '../../../hooks/useHRAdminEmployees';


const FlatListViewReconciliationBalances = React.memo(({ styles, t, control,
    selectedEmployee, CalculateEmplRevisedAllowance, reconcileBalances, index, setValue, watch, setState, state, timer,
    limitedData, width
}) => {

    //#region Variables
    const [calendarVisible, setCalendarVisible] = useState(false);
    const [showCalendarStartDate, setShowCalendarStartDate] = useState(false);
    const [showCalendarEndDate, setShowCalendarEndDate] = useState(false);
    const [startDate, setStartDate] = useState([]);
    const [endDate, setEndDate] = useState([]);
    const [calendarPressed, setCalendarPressed] = useState();
    const [difference, setDifference] = useState();
    const [hasRevisedAllowance, setHasRevisedAllowance] = useState(false);
    const [dateError, setDateError] = useState(false);
    const allowance = useWatch({ control, name: `data[${index}].allowance` }); //watch allowance changes
    //#endregion

    //#region UseEffects
    useEffect(() => {
        const subscription = watch((value, { name }) => {
            const data = value?.data[index];
            if (!data) return;

            // Check if all values are false
            if (
                !data.startDateCheckbox &&
                !data.dFromOtherCheckbox &&
                !data.endDateCheckbox &&
                !data.dToOtherCheckbox
            ) {
                setValue(`data[${index}].dFromOtherCheckbox`, true);
                setValue(`data[${index}].dToOtherCheckbox`, true);
                return;
            }

            switch (name) {
                case `data[${index}].startDateCheckbox`:
                    if (data.startDateCheckbox) {
                        setValue(`data[${index}].dFromOtherCheckbox`, false);
                        setValue(`data[${index}].startDate.startDate`, limitedData?.startDate)
                        setStartDate({ startDate: limitedData?.startDate })
                    }
                    break;
                case `data[${index}].dFromOtherCheckbox`:
                    if (data.dFromOtherCheckbox) setValue(`data[${index}].startDateCheckbox`, false);
                    break;
                case `data[${index}].endDateCheckbox`:
                    if (data.endDateCheckbox) {
                        if (limitedData?.endDate === undefined || limitedData?.endDate === null) {
                            setState('noEndDateMess');
                            setValue(`data[${index}].endDateCheckbox`, false);
                        }
                        else {
                            setValue(`data[${index}].dToOtherCheckbox`, false)
                            setValue(`data[${index}].endDate.startDate`, limitedData?.endDate)
                            setEndDate({ startDate: limitedData?.endDate })
                        }
                    }
                    break;
                case `data[${index}].dToOtherCheckbox`:
                    if (data.dToOtherCheckbox) setValue(`data[${index}].endDateCheckbox`, false);
                    break;
                default:
                    break;
            }
        });
        return () => subscription.unsubscribe();
    }, [watch, index, setValue]);

    useEffect(() => {
        timer();
    }, [state])

    useEffect(() => {
        setValue(`data[${index}].startDate.startDate`, startDate?.startDate);
    }, [startDate])

    useEffect(() => {
        setValue(`data[${index}].endDate.startDate`, endDate?.startDate);
    }, [endDate])
    //#endregion

    //#region Show / Hide
    const onShowCalendarPress = (setShowCalendar, showCalendar, date, setDate, btn) => {
        if (calendarPressed === btn) {
            setCalendarPressed(null);
            setCalendarVisible(false);
            setShowCalendar(!showCalendar)
        }
        else {
            setCalendarPressed(btn);
            setCalendarVisible(true);
            setShowCalendar(!showCalendar)
        }
    }
    //#endregion

    //#region Helpers
    const reconcilebalances = () => {
        setState('reconciliationMess');
        reconcileBalances(selectedEmployee?.employeeID, difference, endDate?.startDate).then((res) => {
            setState('reconciliationSuccMess');
        })
    }

    const calculateAllowance = (item) => {
        let dFrom = startDate?.startDate, dTo = endDate?.startDate;
        if (!isStartDateBeforeEndDate(dFrom, dTo)) return;
        setHasRevisedAllowance(false);
        setState('calcRevAllowanceMess')
        CalculateEmplRevisedAllowance(user = selectedEmployee?.employeeID, startDate?.startDate, endDate?.startDate).then((res) => {
            let revAllowance = res?.RevisedAllowance;
            let diff = allowance - revAllowance;
            setDifference(Math.ceil(diff));
            setValue(`data[0].revisedAllowance`, revAllowance);
            setValue(`data[0].difference`, diff);
            setHasRevisedAllowance(true);
            setState('calcRevAllowanceSuccMess')
        })
    }

    const isStartDateBeforeEndDate = (dFrom, dTo) => {
        if (!dFrom || !dTo) return false;
        const start = new Date(dFrom);
        const end = new Date(dTo);
        if (start > end) {
            setDateError(true);
            setState('startDateBeforeEndDateMess')
            return false;
        } else {
            console.log(start, end)
            return true;
        }
    }
    //#endregion 

    //#region Calendar
    const renderCalendar = () => {
        return (
            <SafeAreaView style={styles.secondLine}>
                {/* calendar view */}
                <View style={{
                    justifyContent: 'center',
                    alignContent: 'center',
                    borderRadius: 10,
                    borderWidth: 0,
                    borderColor: colors.border_card,
                }}>
                    <CustomCalendar
                        calendarType={'RangePicker'}
                        setRange={calendarPressed === 'startDate' ? setStartDate : setEndDate}
                        range={calendarPressed === 'startDate' ? startDate : endDate}
                        allowSingleDate={true}
                        startingYear={1990}
                    />
                </View>
            </SafeAreaView>
        )
    }
    //#endregion

    return (
        <View style={[width < 1300 ? { width: '100%', height: '100%' } : styles.container]}>
            <SafeAreaView>
                <SafeAreaView>
                    <View style={{ flexDirection: 'row' }}>
                        <View style={{ width: '45%' }}>
                            <CustomLabel value={t(`common:accLeaveBalances`)} type='EDIT_EMPLOYEE_HEADER' />
                        </View>
                        <CustomLabel value={t(`common:recBalances`)} type='EDIT_EMPLOYEE_HEADER' />
                    </View>
                    {/* Main View */}
                    <SafeAreaView style={styles.rowFlatList}>
                        <SafeAreaView style={{ width: '40%' }}>
                            <View style={styles.itemFlatlist}>
                                <SafeAreaView style={styles.rowFlatList}>
                                    <View style={styles.nameColumn}>
                                        <CustomLabel value={t(`common:leavebf`)} type='SUBTITLENOFLEX' />
                                    </View>
                                    <View style={{ marginBottom: '1%' }}>
                                        <CustomControlledInput
                                            name={`data[${index}].broughtforward`}
                                            control={control}
                                            editable={false}
                                            type='EDIT_EMPLOYEE'
                                        />
                                    </View>
                                </SafeAreaView>
                            </View>
                            <View style={styles.itemFlatlist}>
                                <SafeAreaView style={styles.rowFlatList}>
                                    <View style={styles.nameColumn}>
                                        <CustomLabel value={t(`common:leavebfExpired`)} type='SUBTITLENOFLEX' />
                                    </View>
                                    <View style={{ marginBottom: '1%' }}>
                                        <CustomControlledInput
                                            name={`data[${index}].broughtforwardexpired`}
                                            control={control}
                                            editable={false}
                                            type='EDIT_EMPLOYEE'
                                        />
                                    </View>
                                </SafeAreaView>
                            </View>
                            <View style={styles.itemFlatlist}>
                                <SafeAreaView style={styles.rowFlatList}>
                                    <View style={styles.nameColumn}>
                                        <CustomLabel value={t(`common:allowance`)} type='SUBTITLENOFLEX' />
                                    </View>
                                    <View style={{ marginBottom: '1%' }}>
                                        <CustomControlledInput
                                            name={`data[${index}].allowance`}
                                            control={control}
                                            editable={false}
                                            type='EDIT_EMPLOYEE'
                                        />
                                    </View>
                                </SafeAreaView>
                            </View>
                            <View style={styles.itemFlatlist}>
                                <SafeAreaView style={styles.rowFlatList}>
                                    <View style={styles.nameColumn}>
                                        <CustomLabel value={t(`common:taken`)} type='SUBTITLENOFLEX' />
                                    </View>
                                    <View style={{ marginBottom: '1%' }}>
                                        <CustomControlledInput
                                            name={`data[${index}].taken`}
                                            control={control}
                                            editable={false}
                                            type='EDIT_EMPLOYEE'
                                        />
                                    </View>
                                </SafeAreaView>
                            </View>
                            <View style={styles.itemFlatlist}>
                                <SafeAreaView style={styles.rowFlatList}>
                                    <View style={styles.nameColumn}>
                                        <CustomLabel value={t(`common:paidLost`)} type='SUBTITLENOFLEX' />
                                    </View>
                                    <View style={{ marginBottom: '1%' }}>
                                        <CustomControlledInput
                                            name={`data[${index}].paid`}
                                            control={control}
                                            editable={false}
                                            type='EDIT_EMPLOYEE'
                                        />
                                    </View>
                                </SafeAreaView>
                            </View>
                            <View style={styles.itemFlatlist}>
                                <SafeAreaView style={styles.rowFlatList}>
                                    <View style={styles.nameColumn}>
                                        <CustomLabel value={t(`common:remaining`)} type='SUBTITLENOFLEX' />
                                    </View>
                                    <View style={{ marginBottom: '1%' }}>
                                        <CustomControlledInput
                                            name={`data[${index}].remaining`}
                                            control={control}
                                            editable={false}
                                            type='EDIT_EMPLOYEE'
                                        />
                                    </View>
                                </SafeAreaView>
                            </View>
                        </SafeAreaView>
                        <SafeAreaView style={styles.verticalLine}></SafeAreaView>
                        {/* Right Side */}
                        <SafeAreaView>
                            <View style={styles.itemFlatlist}>
                                <SafeAreaView style={styles.rowFlatList}>
                                    <View style={{ flexDirection: 'row' }}>
                                        <CustomControlledCheckbox
                                            control={control}
                                            name={`data[${index}].startDateCheckbox`}
                                        />
                                        <CustomLabel value={t(`common:startDateEmployment`)} type='SUBTITLENOFLEX' />
                                    </View>
                                    <View style={{ flexDirection: 'row' }}>
                                        <CustomControlledCheckbox
                                            control={control}
                                            name={`data[${index}].dFromOtherCheckbox`}
                                        />
                                        <CustomLabel value={t(`common:other`)} type='SUBTITLENOFLEX' />
                                    </View>
                                    <SafeAreaView style={styles.row}>
                                        <CustomControlledInput
                                            name={`data[${index}].startDate.startDate`}
                                            control={control}
                                            editable={false}
                                            type='EDIT_EMPLOYEE'
                                        />
                                        <Ionicons
                                            name={calendarPressed === 'startDate' ? "calendar" : "calendar-outline"}
                                            style={styles.icons}
                                            onPress={() => onShowCalendarPress(setShowCalendarStartDate, showCalendarStartDate, startDate, setStartDate, 'startDate')}
                                        />
                                    </SafeAreaView>
                                </SafeAreaView>
                            </View>
                            {(calendarPressed === 'startDate' && calendarVisible) &&
                                renderCalendar()
                            }
                            <View style={styles.itemFlatlist}>
                                <SafeAreaView style={styles.rowFlatList}>
                                    <View style={{ flexDirection: 'row' }}>
                                        <CustomControlledCheckbox
                                            control={control}
                                            name={`data[${index}].endDateCheckbox`}
                                        />
                                        <CustomLabel value={t(`common:dateOfTermination`)} type='SUBTITLENOFLEX' />
                                    </View>
                                    <View style={{ flexDirection: 'row' }}>
                                        <CustomControlledCheckbox
                                            control={control}
                                            name={`data[${index}].dToOtherCheckbox`}
                                        />
                                        <CustomLabel value={t(`common:other`)} type='SUBTITLENOFLEX' />
                                    </View>
                                    <SafeAreaView style={styles.row}>
                                        <CustomControlledInput
                                            name={`data[${index}].endDate.startDate`}
                                            control={control}
                                            editable={false}
                                            type='EDIT_EMPLOYEE'
                                        />
                                        <Ionicons
                                            name={calendarPressed === 'endDate' ? "calendar" : "calendar-outline"}
                                            style={styles.icons}
                                            onPress={() => onShowCalendarPress(setShowCalendarEndDate, showCalendarEndDate, endDate, setEndDate, 'endDate')}
                                        />
                                    </SafeAreaView>
                                </SafeAreaView>
                            </View>
                            {dateError &&
                                <View>Error</View>
                            }
                            {(calendarPressed === 'endDate' && calendarVisible) &&
                                renderCalendar()
                            }
                            <View style={styles.itemFlatlist}>
                                <SafeAreaView style={styles.rowFlatList}>
                                    <CustomButton
                                        iconName={'calculator'}
                                        onPress={() => {
                                            calculateAllowance()
                                        }}
                                        text={t(`common:calcRevisedAllowance`)}
                                        show='EDIT_EMPLOYEE_REV_ALLOWANCE'
                                        type='EDIT_EMPLOYEE_REV_ALLOWANCE'
                                        textTop='0'
                                        sz={30} />
                                </SafeAreaView>
                            </View>
                            <View style={[styles.itemFlatlist, { marginTop: '3%' }]}>
                                <SafeAreaView style={styles.rowFlatList}>
                                    <View style={styles.nameColumn}>
                                        <CustomLabel value={t(`common:revisedAllowance`)} type='SUBTITLENOFLEX' />
                                    </View>
                                    <CustomControlledInput
                                        name={`data[${index}].revisedAllowance`}
                                        control={control}
                                        editable={false}
                                        type='EDIT_EMPLOYEE'
                                    />
                                </SafeAreaView>
                            </View>
                            <View style={styles.itemFlatlist}>
                                <SafeAreaView style={styles.rowFlatList}>
                                    <View style={styles.nameColumn}>
                                        <CustomLabel value={t(`common:difference`)} type='SUBTITLENOFLEX' />
                                    </View>
                                    <CustomControlledInput
                                        name={`data[${index}].difference`}
                                        control={control}
                                        editable={false}
                                        type='EDIT_EMPLOYEE'
                                    />

                                </SafeAreaView>
                            </View>
                            {hasRevisedAllowance &&
                                <View>
                                    <SafeAreaView style={styles.rowFlatList}>
                                        <CustomButton
                                            onPress={() => {
                                                reconcilebalances()
                                            }}
                                            text={t(`common:reconcileBalances`)}
                                            show='EDIT_EMPLOYEE_REV_ALLOWANCE'
                                            type='EDIT_EMPLOYEE_REV_ALLOWANCE'
                                            textTop='0'
                                            sz={30} />
                                    </SafeAreaView>
                                </View>
                            }
                        </SafeAreaView>
                    </SafeAreaView>
                </SafeAreaView>
            </SafeAreaView>
        </View>
    );
});


const HRAdminReconciliationBalances = ({ props }) => {
    const { selectedEmployee, convertDate, flatlistEditPress, styles,
        modal, t, CalculateEmplRevisedAllowance, reconcileBalances, colors, modalVisible, setModalVisible
    } = props;
    const ref = useRef(null);
    const { getEmployeeAccumulatedBalances, getLimitedData } = useHRAdminEmployees();
    const [isLoading, setIsLoading] = useState(false);
    const { control, formState: { errors }, setValue, watch, reset } = useForm({
        defaultValues: {
            data: []
        }
    });
    const [state, setState] = useState(null);
    const [showState, setShowState] = useState(false);
    const [limitedData, setLimitedData] = useState({});
    const { width, height } = useWindowDimensions();

    useEffect(() => {
        setIsLoading(true);
        getEmployeeAccumulatedBalances(selectedEmployee?.employeeID).then((res) => {
            reset({ data: res }); // Update form default values with fetched data
            getLimitedData(selectedEmployee?.employeeID, "mnuEmployee").then((res) => {
                let employeeData = res?.data[0];
                setLimitedData({ startDate: convertDate(employeeData?.startdate), endDate: convertDate(employeeData?.enddate) });
                setIsLoading(false);
            })
        })
    }, [])

    useEffect(() => {
        timer();
    }, [state]);


    function timer() {
        if (state) {
            setShowState(true);
            const timer = setTimeout(() => {
                setShowState(false);
                setState(null);

            }, 10000);
            return () => {
                clearTimeout(timer)
                setState(null);
            };
        }
    }

    //#region Handlers
    const handleAddPress = () => {
        rowAdd(emplDepts, setEmplDepts, [], [], ref, t, [], [], changesDepts, setChangesDepts, addGuid = true, key = 'rowguid');
    };

    const handleRemovePress = () => {
        handleCancelChanges(modal?.setData, originalFamilyDetails, setDeletedItems, modal?.setChanges, []);
    };
    //#endregion

    //#region Modal
    const closeModal = () => {
        setModalVisible(!modalVisible);
    }
    //#endregion

    //#region Loading
    if (isLoading)
        return (
            <View style={styles.loader}>
                <ActivityIndicator animating={true} color={colors.blue} />
            </View>
        )
    //#endregion

    return (
        <>
            <View style={styles.iconRow}>
                {modal?.allowsAddDelete ? (
                    <View style={styles.leftIcons}>
                        <Ionicons
                            name={"add-circle-outline"}
                            style={styles.icon}
                            onPress={handleAddPress}
                        />
                        <Ionicons
                            name={"remove-circle-outline"}
                            style={styles.icon}
                            onPress={handleRemovePress}
                        />
                    </View>
                ) : (
                    <View style={styles.leftIcons}></View>
                )}
                <View style={[styles.rightIcon, { flexDirection: 'row' }]}>
                    {showState && <CustomLabel
                        value={`${t('common:state')}: ${t(`common:${state}`)}`}
                        type='EDIT_EMPLOYEE_STATE'
                    />}
                    <Ionicons
                        name={"close-circle-outline"}
                        style={styles.icon}
                        onPress={closeModal}
                    />
                </View>
            </View>
            <Card
                style={[styles.cardStyleLocation]} >
                <Card.Content>
                    <FlatListViewReconciliationBalances
                        styles={styles}
                        control={control}
                        index={0}
                        selectedEmployee={selectedEmployee}
                        CalculateEmplRevisedAllowance={CalculateEmplRevisedAllowance}
                        reconcileBalances={reconcileBalances}
                        handleEditPress={flatlistEditPress}
                        setValue={setValue}
                        watch={watch}
                        limitedData={limitedData}
                        timer={timer}
                        setState={setState}
                        state={state}
                        width={width}
                        t={t}
                    />
                </Card.Content>
            </Card>
        </>
    );
};
export default HRAdminReconciliationBalances;